<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-close-button="false"
    :show-title="true"
    :width="'500px'"
    :height="265"
    :title="popupConfig.title"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-form gc-popup-reserve-lot',
    }"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>

    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />

    <div class="css-v2 gc-popup-form" v-if="popupConfig.isPopupShow">
      <DxForm
        ref="gc-header-form"
        :form-data="model"
        :items="getHeaderFormItems"
        label-location="left"
        :show-colon-after-label="false"
        :show-required-mark="false"
        :show-validation-summary="false"
        :col-count="1"
        :labelLocation="'left'"
      />
    </div>

    <div class="footer modal-popup-footer-action-container">
      <DxButton
        text="Cancel"
        type="default"
        styling-mode="contained"
        class="dx-button dx-button-mode-contained dx-button-normal dx-button-has-text"
        @click="onCancelPopupHandler"
      />

      <DxButton
        text="Save Reservation"
        type="default"
        styling-mode="contained"
        class="save-btn-cl dx-button dx-button-mode-contained dx-button-default dx-button-has-text"
        @click="onSavePopupHandler"
        :ref="'footer-save-btn'"
      />
    </div>

    <DxLoadPanel
      :position="{ of: '#container-wrapper' }"
      :visible.sync="loadingVisible"
      :show-indicator="true"
      :show-pane="true"
      :shading="true"
      :hide-on-outside-click="false"
      shading-color="rgba(0,0,0,0)"
    />
  </DxPopup>
</template>
<script>
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { mapGetters } from "vuex";
import { InshellService } from "../../../_services/api/inventory/inshell.service";
import { IsResponseDataValid } from "../../../_helpers/ui/helpers";

export default {
  mixins: [DataGridMixin],
  components: {},
  data() {
    return {
      loadingVisible: false,
      model: {
        CustomerCode: null,
        AgentCode: null,
        SubRegionCode: null,
      },
      cascadeDriver: null,
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {
        return {
          isPopupShow: false,
          formMode: "create",
          formKey: 1,
          secondaryTitle: "",
        };
      },
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    onHide: {
      type: Function,
      default: () => {},
    },
  },
  async created() {},
  methods: {
    /* Popup Events */
    onShown() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
    },

    /*
    Popup Hide Event
    */
    onPopupHide(repaint = true) {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
      this.cascadeDriver = null;
      this.model.CustomerCode = null;
      this.model.AgentCode = null;
      this.model.SubRegionCode = null;

      this.$emit("setIsVisible", false);
      this.onHide(repaint);
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    /**
     * Popup Initialized Event
     * @param e
     */
    onInitialized(e) {
      e.component.registerKeyHandler("escape", (arg) => {
        arg.stopPropagation();

        this.$nextTick(() => {
          this.onCancelPopupHandler();
        });
      });
    },

    /**
     * Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          },
        );
        if (confirm) {
          this.onPopupHide();
        }
      }
    },

    async onSavePopupHandler() {
      if (!this.model.SubRegionCode) {
        this.$alert("Sub Region is required", "Validation Error", {
          confirmButtonText: "OK",
        });
        return;
      } else {
        this.$emit("onSaveReserveLot", {
          LotNo: this.popupConfig.dataModel.LotNo,
          CustomerCode: this.model.CustomerCode,
          AgentCode: this.model.AgentCode,
          SubRegionCode: this.model.SubRegionCode,
        });
      }
    },
    updateFormValues(dataField, value) {
      const form = this.$refs["gc-header-form"].instance;
      form.beginUpdate();
      form.updateData(dataField, value);
      form.endUpdate();

      if (!value) {
        this.model[dataField] = null;
      }
    },

    getEditor(dataField) {
      return this.$refs["gc-header-form"].instance.getEditor(dataField);
    },

    updateEditorDataSource(dataField, url, params, removeDataSource = false) {
      const editor = this.getEditor(dataField);
      if (editor) {
        if (removeDataSource) {
          editor.option("dataSource", []);
          return;
        } else {
          editor.option(
            "dataSource",
            InshellService.dataSourceConfig(url, params),
          );
        }
      }
    },

    resetAllDataSources(
      resetCustomer = true,
      resetAgent = true,
      resetSubRegion = true,
    ) {
      if (resetCustomer) {
        this.updateEditorDataSource("CustomerCode", "api/CustomerList", {
          filter: ["Inactive", "=", "N"],
          select: ["Code", "Name", "AgentCode", "SubregionCode", "Inactive"],
        });
      }
      if (resetAgent) {
        this.updateEditorDataSource("AgentCode", "api/CustomerAgentList", {});
      }
      if (resetSubRegion) {
        this.updateEditorDataSource("SubRegionCode", "api/CustomerSubRegion", {
          select: ["Code", "CustomerRegionCode", "Inactive"],
        });
      }
    },

    onCustomerSelectionChanged(e) {
      if (e && e.selectedItem) {
        if (!this.cascadeDriver) {
          this.cascadeDriver = "CustomerCode";
        }
        const agentCode = e.selectedItem.AgentCode;
        const subregionCode = e.selectedItem.SubregionCode;
        if (agentCode) {
          this.updateEditorDataSource("AgentCode", "api/CustomerAgentList", {
            filter: [
              ["AgentCode", "=", agentCode],
              "and",
              ["CustomerCodes", "contains", `|${e.selectedItem.Code}|`],
            ],
          });

          this.$nextTick(() => {
            this.updateFormValues("AgentCode", agentCode);
          });
        } else {
          this.updateEditorDataSource("AgentCode", false, false, true);
          this.$nextTick(() => {
            this.updateFormValues("AgentCode", null);
          });
        }
        if (subregionCode) {
          this.updateEditorDataSource(
            "SubRegionCode",
            "api/CustomerSubRegion",
            {
              filter: ["Code", "=", subregionCode],
              select: ["Code", "CustomerRegionCode", "Inactive"],
            },
          );
          this.$nextTick(() => {
            this.updateFormValues("SubRegionCode", subregionCode);
          });
        } else {
          this.resetAllDataSources(false, false, true);
          this.$nextTick(() => {
            this.updateFormValues("SubRegionCode", null);
          });
        }
      } else {
        if (this.cascadeDriver === "CustomerCode") {
          this.cascadeDriver = null;
          this.updateFormValues("AgentCode", null);
          this.updateFormValues("SubRegionCode", null);
          this.resetAllDataSources();
        }
      }
    },

    onAgentSelectionChanged(e) {
      if (e && e.selectedItem) {
        const agentCode = e.selectedItem.AgentCode;
        if (!this.cascadeDriver || !this.model.AgentCode) {
          this.cascadeDriver = "AgentCode";
        }
        if (this.cascadeDriver === "AgentCode") {
          let filter = [["AgentCode", "=", agentCode]];
          if (this.model.SubRegionCode) {
            filter.push("and", [
              "SubregionCode",
              "=",
              this.model.SubRegionCode,
            ]);
          }
          this.updateEditorDataSource("CustomerCode", "api/CustomerList", {
            filter: filter,
            select: ["Code", "Name", "AgentCode", "SubregionCode", "Inactive"],
          });
        }
      } else {
        if (this.cascadeDriver === "AgentCode") {
          this.cascadeDriver = null;
          this.updateFormValues("CustomerCode", null);
          this.updateFormValues("SubRegionCode", null);
          this.resetAllDataSources();
        }
        if (this.model.SubRegionCode) {
          this.updateEditorDataSource("CustomerCode", "api/CustomerList", {
            filter: [["SubregionCode", "=", this.model.SubRegionCode]],
            select: ["Code", "Name", "AgentCode", "SubregionCode", "Inactive"],
          });
        } else {
          this.updateFormValues("CustomerCode", null);
          this.resetAllDataSources();
        }
      }
    },

    onSubRegionSelectionChanged(e) {
      if (e && e.selectedItem) {
        const subRegionCode = e.selectedItem.Code;
        if (!this.cascadeDriver || !this.model.SubRegionCode) {
          this.cascadeDriver = "SubRegionCode";
        }
        if (this.cascadeDriver === "SubRegionCode") {
          let filter = [["SubregionCode", "=", subRegionCode]];
          if (this.model.AgentCode) {
            filter.push("and", ["AgentCode", "=", this.model.AgentCode]);
          }
          this.updateEditorDataSource("CustomerCode", "api/CustomerList", {
            filter: filter,
            select: ["Code", "Name", "AgentCode", "SubregionCode", "Inactive"],
          });
        }
      } else {
        if (this.cascadeDriver === "SubRegionCode") {
          this.cascadeDriver = null;
          this.updateFormValues("CustomerCode", null);
          this.updateFormValues("AgentCode", null);
          this.resetAllDataSources();
        }
        if (this.model.AgentCode) {
          this.updateEditorDataSource("CustomerCode", "api/CustomerList", {
            filter: [["AgentCode", "=", this.model.AgentCode]],
            select: ["Code", "Name", "AgentCode", "SubregionCode", "Inactive"],
          });
        } else {
          this.updateFormValues("CustomerCode", null);
          this.resetAllDataSources();
        }
      }
    },

    /**
     * Agent Value Changed Event
     * This event is triggered when the value of the AgentCode select box changes. It updates the SubRegionCode select box based on the selected AgentCode.
     * @param e The event object containing the new value of the AgentCode select box.
     */
    async onAgentValueChanged(e) {
      if (e && e.value && e.event) {
        try {
          const response =
            await InshellService.getAlmondcoCustomerAgentSubRegionByAgentCode(
              e.value,
            );

          if (IsResponseDataValid(response)) {
            const data = response.data.value;
            if (data && data.length > 0) {
              if (data.length === 1) {
                const subRegionCode = data[0].SubRegionCode;
                this.updateFormValues("SubRegionCode", subRegionCode);
              }

              let filter = [];
              data.forEach((item) => {
                if (filter.length > 0) {
                  filter.push("or");
                }
                filter.push(["Code", "=", item.SubRegionCode]);
              });
              this.updateEditorDataSource(
                "SubRegionCode",
                "api/CustomerSubRegion",
                {
                  filter: filter.length > 0 ? filter : null,
                  select: ["Code", "CustomerRegionCode", "Inactive"],
                },
              );
            } else {
              this.updateFormValues("SubRegionCode", null);
              this.updateEditorDataSource("SubRegionCode", false, false, true);
            }
          } else {
            this.updateFormValues("SubRegionCode", null);
            this.updateEditorDataSource("SubRegionCode", false, false, true);
          }
        } catch (error) {
          if (error) {
            this.updateFormValues("SubRegionCode", null);
            this.updateEditorDataSource("SubRegionCode", false, false, true);
          }
        }
      }
    },

    /**
     * Sub Region Value Changed Event
     * This event is triggered when the value of the SubRegionCode select box changes. It updates the AgentCode select box based on the selected SubRegionCode.
     * @param e The event object containing the new value of the SubRegionCode select box.
     */
    async onSubRegionValueChanged(e) {
      if (e && e.event && e.value) {
        try {
          const response =
            await InshellService.getAlmondcoCustomerAgentSubRegionByCode(
              e.value,
            );

          if (IsResponseDataValid(response)) {
            const data = response.data.value;

            if (data && data.length > 0) {
              if (data.length === 1) {
                const agentCode = data[0].AgentCode;
                this.updateFormValues("AgentCode", agentCode);
              }

              let filter = [];
              data.forEach((item) => {
                if (filter.length > 0) {
                  filter.push("or");
                }
                filter.push(["AgentCode", "=", item.AgentCode]);
              });
              this.updateEditorDataSource(
                "AgentCode",
                "api/CustomerAgentList",
                {
                  filter: filter.length > 0 ? filter : null,
                },
              );
            } else {
              this.updateFormValues("AgentCode", null);
              this.updateEditorDataSource("AgentCode", false, false, true);
            }
          } else {
            this.updateFormValues("AgentCode", null);
            this.updateEditorDataSource("AgentCode", false, false, true);
          }
        } catch (error) {
          if (error) {
            this.updateFormValues("AgentCode", null);
            this.updateEditorDataSource("AgentCode", false, false, true);
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },

    getHeaderFormItems() {
      return [
        {
          dataField: "CustomerCode",
          label: { text: "Customer" },
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: InshellService.dataSourceConfig("api/CustomerList", {
              filter: ["Inactive", "=", "N"],
              select: [
                "Code",
                "Name",
                "AgentCode",
                "SubregionCode",
                "Inactive",
              ],
            }),
            displayExpr: (e) => {
              if (e) return `${e.Code} - ${e.Name}`;
              else undefined;
            },
            valueExpr: "Code",
            searchExpr: ["Name", "Code"],
            searchMode: "contains",
            showClearButton: true,
            searchEnabled: true,
            dropDownOptions: { minWidth: 250 },
            itemTemplate: (data) => {
              return `<div class="custom-auto-complete" id="${data.Code}">
                        <span class="auto-complete-primary">${data.Name}</span>
                        <span class="record-secondary gc-grid-code">${data.Code}</span>
                      </div>`;
            },
            onSelectionChanged: (e) => {
              this.onCustomerSelectionChanged(e);
            },
          },
        },
        {
          dataField: "AgentCode",
          label: { text: "Agent" },
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: InshellService.dataSourceConfig(
              "api/CustomerAgentList",
              {},
            ),
            displayExpr: (e) => {
              if (e) return `${e.AgentCode} - ${e.AgentName}`;
              else undefined;
            },
            valueExpr: "AgentCode",
            searchExpr: ["AgentCode", "AgentName"],
            searchMode: "contains",
            showClearButton: true,
            searchEnabled: true,
            dropDownOptions: { minWidth: 250 },
            onSelectionChanged: (e) => {
              this.onAgentSelectionChanged(e);
            },
            onValueChanged: (e) => {
              this.onAgentValueChanged(e);
            },
            itemTemplate: (data) => {
              return `<div class="custom-auto-complete" id="${data.AgentCode}">
                        <span class="auto-complete-primary">${data.AgentName}</span>
                        <span class="record-secondary gc-grid-code">${data.AgentCode}</span>
                      </div>`;
            },
          },
        },
        {
          dataField: "SubRegionCode",
          label: { text: "Sub Region" },
          editorType: "dxSelectBox",
          isRequired: true,
          editorOptions: {
            dataSource: InshellService.dataSourceConfig(
              "api/CustomerSubRegion",
              {
                select: ["Code", "CustomerRegionCode", "Inactive"],
              },
            ),
            displayExpr: "Code",
            valueExpr: "Code",
            searchExpr: ["Code", "CustomerRegionCode"],
            searchMode: "contains",
            showClearButton: true,
            searchEnabled: true,
            dropDownOptions: { minWidth: 250 },
            onSelectionChanged: (e) => {
              this.onSubRegionSelectionChanged(e);
            },
            onValueChanged: (e) => {
              this.onSubRegionValueChanged(e);
            },
          },
        },
      ];
    },

    /**
     * Get Toolbar Items
     */
    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
          },
        },
      ];
    },
  },
  watch: {
    "popupConfig.isPopupShow": {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.resetAllDataSources();
          });
        }
      },
    },
    getHotKeySave: {
      handler(val) {
        if (val && this.getVisible) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          this.onSavePopupHandler();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-reserve-lot {
  .dx-popup-content {
    padding: 12px;
  }

  .css-v2.gc-popup-form {
    padding: 12px;

    .dx-form.dx-widget {
      background: white;
      padding: 12px;
    }
  }
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }

  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .dx-datagrid-header-panel {
    height: 0px !important;
  }

  .dx-datagrid .dx-datagrid-content {
    .dx-datagrid-table .dx-row .dx-editor-cell:not(.description-column) {
      padding-right: 5px !important;
      padding-left: 5px !important;
    }

    .dx-datebox {
      .dx-placeholder::before {
        padding-left: unset !important;
        padding-bottom: unset !important;
        padding-top: unset !important;
      }
    }
  }

  .edit-cell-textbox-field {
    .dx-placeholder::before {
      padding-left: 0 !important;
      padding-bottom: 2px !important;
    }
  }

  .css-v2.gc-popup .dx-popup-content .footer {
    padding: 10px 0px;
  }

  .modal-popup-footer-action-container {
    padding-top: 10px;
    bottom: 0;
    margin-right: 0px;
    height: 45px;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    .save-btn-cl {
      // margin-right: 10px;
      width: 165px;
    }

    .cancel-btn-cl {
      margin-right: 10px;
      width: 120px;
    }
  }
}
</style>
